/**
 * Helper para mapeo y transformación de datos entre layer.config y formularios
 * de configuración de estados de progreso
 */

/**
 * Obtiene un valor de un objeto usando una ruta de propiedades (ej: 'a.b.c')
 * @param {Object} obj - Objeto del cual extraer el valor
 * @param {string} path - Ruta de propiedades separadas por puntos
 * @returns {*} Valor encontrado o undefined
 */
export const getNestedValue = (obj, path) => {
  return path.split('.').reduce((current, prop) => current?.[prop], obj);
};

/**
 * Mapeo de configuración: define la ruta en layer.config y el campo destino en form
 * @returns {Array<{path: string, formField: string, transform?: Function}>}
 */
export const getFormFieldMapping = () => {
  return [
    { path: 'statuses.avance_method', formField: 'advance_method' },
    { path: 'statuses.weighting_criteria', formField: 'weighting_criteria' },
    { path: 'statuses.progress.visibility_policy', formField: 'visibility_policy' },
    { path: 'statuses.progress.allow_multi_status_entry', formField: 'allow_multi_status_entry' },
    { path: 'statuses.progress.actions.permitted', formField: 'actions_permitted' },
    { path: 'statuses.progress.actions.capabilities.allow_rollback_to_previous', formField: 'allow_rollback_to_previous' },
    { path: 'statuses.progress.actions.capabilities.allow_reset_to_initial', formField: 'allow_reset_to_initial' },
    { path: 'statuses.progress.actions.capabilities.allow_archiving_states', formField: 'allow_archiving_states' },
  ];
};

/**
 * Inicializa el formulario con los valores de layer.config
 * @param {Object} layer - Objeto layer con la propiedad metadata.config o config
 * @param {Object} form - Instancia del formulario (vform) a inicializar
 * @param {Function} specialFieldsHandler - Función opcional para manejar campos especiales
 */
export const initializeFormFromConfig = (layer, form, specialFieldsHandler = null) => {
  // El layer puede tener config en metadata.config o directamente en config
  const config = layer?.metadata?.config || layer?.config || {};
  const fieldMapping = getFormFieldMapping();

  // Aplicar mapeo de campos
  fieldMapping.forEach(({ path, formField, transform }) => {
    const value = getNestedValue(config, path);

    if (value !== undefined) {
      // Aplicar transformación si existe, sino usar el valor directamente
      form[formField] = transform ? transform(value) : value;
    }
  });

  // Manejar campos especiales si se proporciona un handler
  if (specialFieldsHandler && typeof specialFieldsHandler === 'function') {
    specialFieldsHandler(config);
  }
};
